import React, { ComponentProps } from "react";
import BaseModal from "./BaseModal";
import Button from "./Button";
import "../../styles/ConfirmationModal.css";

export type ConfirmOptions = {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmDisabled?: boolean;
  variant?: ComponentProps<typeof Button>["variant"];
};

interface Props extends ConfirmOptions {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationModal: React.FC<Props> = ({
  title = "Confirm action",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmDisabled = false,
  variant = "primary",
  isOpen,
  onCancel,
  onConfirm,
}) => {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
      width="460px"
      footer={
        <>
          <Button variant="secondary" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button
            variant={variant}
            onClick={onConfirm}
            disabled={confirmDisabled}
            autoFocus
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="cm-message">{message}</div>
    </BaseModal>
  );
};

export default ConfirmationModal;
